// extracted by mini-css-extract-plugin
export var linkButton = "LinkCardV2-module--linkButton--HtxBu";
export var linkCardContainer = "LinkCardV2-module--linkCardContainer--CRxVR";
export var linkCard = "LinkCardV2-module--linkCard--MhwWg";
export var linkCardBackground = "LinkCardV2-module--linkCardBackground--j3dDC";
export var linkCardContent = "LinkCardV2-module--linkCardContent--l2dqr";
export var linkCardIcon = "LinkCardV2-module--linkCardIcon--mmIfU";
export var linkCardTitle = "LinkCardV2-module--linkCardTitle--LuXDd";
export var customLinkIcon = "LinkCardV2-module--customLinkIcon--7o+Pz";